import CompactEmptyState from 'components/EmptyState/CompactEmptyState';
import { RecordSection } from './RecordLayout';

/**
 * « Tâches » or « Derniers échanges » on a record: a line per exchange, its
 * title and where it comes from over its text, its date on the right (red
 * with « En retard » when `late`). A line with `onOpen` opens it; `empty` is
 * the compact empty state ({ glyph, title, description }); `header` goes
 * under the title (tabs).
 */
const ExchangeList = ({ title, header, items, empty }) => (
  <RecordSection title={title}>
    {header && <div className="mb-2">{header}</div>}
    {!items.length && <CompactEmptyState compact {...empty} />}
    {items.map((item) => (
      <div
        key={item.key}
        role={item.onOpen ? 'button' : undefined}
        tabIndex={item.onOpen ? 0 : undefined}
        onClick={item.onOpen}
        onKeyDown={item.onOpen ? (event) => event.key === 'Enter' && item.onOpen() : undefined}
        className={`-mx-2 flex items-start justify-between gap-4 rounded-lg border-b border-gray-100 px-2 py-2.5 last:border-0 ${
          item.onOpen ? 'cursor-pointer transition-colors hover:bg-gray-50' : ''
        }`}
      >
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-gray-900">{item.title}</p>
          {item.detail && <p className="truncate text-xs text-gray-600">{item.detail}</p>}
        </div>
        <p className={`shrink-0 text-xs ${item.late ? 'font-medium text-red-600' : 'text-gray-600'}`}>
          {item.late ? `En retard · ${item.when}` : item.when}
        </p>
      </div>
    ))}
  </RecordSection>
);

export default ExchangeList;
